export default function GlowDivider() {
  return (
    <div className='pointer-events-none absolute right-0 bottom-0 left-0 z-20 h-px w-full'>
      <div className='via-foreground/20 dark:via-foreground/30 h-px w-full bg-gradient-to-r from-transparent to-transparent' />
      <div className='from-primary/10 dark:from-primary/20 absolute top-0 left-1/2 h-[40px] w-3/4 max-w-3xl -translate-x-1/2 bg-gradient-to-b to-transparent blur-xl' />
    </div>
  );
}
